import * as types from '../constants/actionTypes';

const initialState = {
  dashboard: null,
  vendorProducts: [],
  loading: false,
  vendorProductsLoading: false,
  error: null,
  filters: {
    date_from: '',
    date_to: '',
    vendor_id: null,
    firm_name: '',
    order_status: '',
    group_by: 'month',
    top_n: 10,
  },
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ANALYTICS_DASHBOARD_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_ANALYTICS_DASHBOARD_SUCCESS:
      return { ...state, loading: false, dashboard: action.payload };
    case types.FETCH_ANALYTICS_DASHBOARD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.FETCH_ANALYTICS_VENDOR_PRODUCTS_REQUEST:
      return { ...state, vendorProductsLoading: true };
    case types.FETCH_ANALYTICS_VENDOR_PRODUCTS_SUCCESS:
      return { ...state, vendorProductsLoading: false, vendorProducts: action.payload || [] };
    case types.FETCH_ANALYTICS_VENDOR_PRODUCTS_FAILURE:
      return { ...state, vendorProductsLoading: false };

    case types.SET_ANALYTICS_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    default:
      return state;
  }
};

export default analyticsReducer;
